import React, { useCallback, useEffect } from 'react';
import { View, StyleSheet, Image, Dimensions } from 'react-native';
import { useKeenSliderNative } from "keen-slider/react-native"
import { useBoundStore } from '@/services/zustand/Store';

interface ModalSlideshowProps {
  images: string[];
}

export const ModalSlideshow = ({ images }: ModalSlideshowProps) => {
  const currentMagazine = useBoundStore(useCallback((state) => state.magazine, []));

  const slider = useKeenSliderNative({
    slides: images.length,
    loop: true,
  });

  useEffect(() => {
    //@ts-ignore
    if (slider.options.slides > 1) {
      const interval = setInterval(() => {
        slider.next();
      }, 3000);

      return () => {
        clearInterval(interval);
      };
    }

  }, [slider]);;

  return (
    //@ts-ignore
    <View {...slider.containerProps} style={styles.slider}>
      {currentMagazine ? (
        <>
          {images.map((image, index) => (
            //@ts-ignore
            <View key={index} {...slider.slidesProps[index]} style={styles.slide}>
              <Image
                source={{ uri: image }}
                style={styles.image}
                resizeMode='contain'
              />
            </View>
          ))
          }
        </>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  slider: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: Dimensions.get('window').width,
    height: Dimensions.get('window').width * .85,
  },
  image: {
    width: Dimensions.get('window').width,
    height: Dimensions.get('window').width * .85,
    resizeMode: 'contain',
  },
});

